import { createFileRoute } from '@tanstack/react-router';
import { LifeBuoy } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';

export const Route = createFileRoute('/org/support')({
  component: OrgSupportPage,
});

function OrgSupportPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Support" subtitle="Get help with your KodPrep organization account." />
      <EmptyState
        icon={LifeBuoy}
        title="Support center — coming soon"
        description="In-app support is on the way. Meanwhile, reach us at support@kodprep.com."
      />
    </div>
  );
}
